/* Styled Components are hard code they will get from server once integrated */
import styled from "styled-components";

export const LivePlayerShade = styled.div`
  width: 54.6%;
  height: 50.2%;
  top: 0;
  ${props => (props.direction === "rtl" ? "left:" : "right:")} 0;
  z-index: 9999;
  position: absolute;
  pointer-events: none;
  background: ${props => `linear-gradient(270deg, rgba(0, 0, 0, 0.00) 0%, ${props.theme.color.black} 100%)`};
  ${props => props.direction === "rtl" && "transform: scaleX(-1)"};
`;

export const LivePlayerShadeMeta = styled.div`
width: 50%;
height: 50.2%;
background: no-repeat;
top: 0;
${props => (props.direction === "rtl" ? "left:" : "right:")} 50rem;
z-index: -9;
position: absolute;
background-color: ${props => props.theme.color.greyDark};
pointer-events: none;
//background: ${props => `linear-gradient(90deg, rgba(8, 33, 37, 0) 0%, ${props.theme.color.greyDark} 100%)`};
${props => props.direction === "rtl" && "transform: scaleX(-1)"};
`;

export const Wrapper = styled.div`
  width: ${props => (props.isFullScreen === true ? "100%" : "54.5%")};
  height: ${props => (props.isFullScreen === true ? "100%" : "50.2%")};
  overflow: hidden;
  position: absolute;
  top: 0;
  ${props => (props.direction === "rtl" ? "left:" : "right:")} 0;
  background-color: ${props => props.theme.color.black};
`;

export const PlayerDiv = styled.div`
  width: 100%;
  height: 100%;
  ${props => (props.isFullScreen === true ? `background-color: ${props.theme.color.black} !important` : "")};

  video {
    width: 100%;
    height: 100%;
  }

  .bmpui-ui-subtitle-label p {
    font-size: ${props => (props.isFullScreen === true ? "2.5rem " : "1.25rem ")} !important;
  }

  .bitmovinplayer-container {
    ${props =>
      props.isFullScreen === true ? "background-color : #000 " : "background-color : transparent"} !important;
  }
`;

export const LowerPlayerControlsAdsMiniPlayer = styled.div`
  width: 100%;
  height: 3.3em;
  position: absolute;
  margin-top: 22em;
  margin-left: 41rem;
  z-index: 9999;
`;

export const AdInfoStyleMiniPlayer = styled.div`
  position: absolute;
  left: ${props =>
    props.direction === "ltr" ? (localStorage.getItem("locale") === "en" ? "5.4vw" : "0.8vw") : "1.4vw"};
  bottom: -2.2rem;
  display: flex;
  p {
    font-weight: 900 !important;
  }
`;
